module.exports = __webpack_public_path__ + "static/media/GitHub.e00328e4.png";